import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { Grid, InputAdornment, TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setProductParamsValid } from '../../Reducers/App/Actions';
import { getCustomData, getProductParamValidations } from '../../Reducers/App/Selectors';
import { useStyles } from './styles';
import { FieldType, InputProps } from '../FormBuilder/types';
import { getErrorMessage } from '../FormBuilder/utils';
import { validate } from '../FormBuilder/validator';
import { setCustomData } from '../../Reducers/Configurator/Actions';

const TextInputField: React.FC<InputProps> = (props) => {
  const { field, float } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const validations = useSelector(getProductParamValidations);

  const storedValue = useSelector((state) => getCustomData(state)?.[field.identifier]);

  const [value, setValue] = useState(storedValue || '');
  const [pristine, setPristine] = useState(true);

  const isFieldValid =
    typeof validations[field.identifier] === 'object'
      ? false
      : validations[field.identifier] === undefined || validations[field.identifier] === true || pristine;

  const errorMessage = getErrorMessage(field, validations[field.identifier]);

  useEffect(() => {
    validateField();
  }, []);

  useEffect(() => {
    if (!pristine) {
      const timeout = setTimeout(() => validateField(), 2000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [value]);

  const handleChange = (e) => {
    if (field.type === FieldType.INTEGER || field.type === FieldType.FLOAT) {
      handleNumberChange(e);
    } else {
      enterValue(e);
    }
  };

  const handleNumberChange = (e) => {
    const pattern = float ? /^([0-9.,]+)?$/ : /^([0-9]+)?$/;
    if (pattern.test(e.target.value)) {
      enterValue(e);
    }
  };

  const enterValue = (e) => {
    setValue(e.target.value);
    setCustomField(e);
  };

  const validateField = () => {
    if (field.validation) {
      const result = validate(value, field.validation);
      dispatch(setProductParamsValid({ [field.identifier]: result }));
    } else {
      dispatch(setProductParamsValid({ [field.identifier]: true }));
    }
  };

  const setCustomField = (e) => {
    dispatch(setCustomData({ [field.identifier]: e.target.value }));
  };

  return (
    <Grid container className={classes.textFieldContainer} direction="row" spacing={0}>
      <Grid item xs={12}>
        <FormControl key={field.identifier} className={classes.formControl}>
          <TextField
            variant={'outlined'}
            size={'small'}
            placeholder={field.placeholderSlug ? t(field.placeholderSlug) : field.placeholder}
            className={classes.textField}
            fullWidth={false}
            onChange={handleChange}
            onBlur={validateField}
            value={value}
            error={!isFieldValid}
            onFocus={() => setPristine(false)}
            helperText={!isFieldValid ? errorMessage : ''}
            type={field.type}
            InputProps={{
              endAdornment: <InputAdornment position="end">{field.additionalText}</InputAdornment>,
            }}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default TextInputField;
